import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom';
import MainNav from '../../Components/Navbar'
import { getDatabase, onValue, ref } from 'firebase/database';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-bs5';
import langptBR from 'datatables.net-plugins/i18n/pt-BR.mjs';
import { Button, Container } from 'react-bootstrap';
import $ from 'jquery';
import '../../css/selected-row.css';
import EditarAluno from '../../Components/EditarAluno';
import ExcluirAluno from '../../Components/ExcluirAluno';

function Alunos() {
    const [selectedRow, setSelectedRow] = useState(null);
    const [alunos, setAlunos] = useState([]);
    const [empresas, setEmpresas] = useState([]);
    const [editRowVisible, setEditRowVisible] = useState(false);
    const [editData, setEditData] = useState([]);

    useEffect(() => {
        if (selectedRow) {
            setEditData(selectedRow);
        }
    }, [selectedRow]);

    function removeClasses() {
        setEditRowVisible(false);
        $('.selected-row').each(function () {
            $(this).removeClass('selected-row').removeClass('table-info');
            setSelectedRow(null);
        });
    }

    useEffect(() => {
        $(document).on("click", ".row-edit-button", function () {
            let rowData = $(this).attr("data-row-data");
            rowData = rowData.split(',')
            $("#edit-aluno-btn").click()
            console.log(rowData); // Parse if the data is a JSON string
        });

        // Cleanup the event listener on unmount
        return () => {
            // table.removeEventListener('click', handleButtonClick);
        };
    }, []);


    const [options, setOptions] = useState({
        columnDefs: [
            { target: 0, visible: false, searchable: false },
            { target: 1, visible: false, searchable: true },
            { target: 2, width: "40%" },
            { target: 3, width: "10%" },
            { target: 4, width: "20%" }
        ],
        columns: [
            { title: 'path' },
            { title: 'ID' },
            { title: 'Aluno' },
            { title: 'Empresa' },
            { title: 'Departamento' },
            // {
            //     title: 'Ações',
            //     render: function (data, type, row, meta) {
            //         return `
            //             <button class="row-edit-button btn btn-primary btn-sm" data-row-data='${row}'>Edit</button>
            //             <button class="row-delete-button btn btn-danger btn-sm" data-row-data='${row}'>Delete</button>
            //         `;
            //     }
            // }
        ],
        paging: true,
        pagingType: "full",
        lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "All"]],
        searching: true,
        ordering: true,
        language: langptBR,
        responsive: true,
        rowCallback: function (row, data) {
            $(row).off('click').on('click', function () {
                if ($(this).hasClass('selected-row')) {
                    removeClasses();
                    setSelectedRow(null);
                    setEditRowVisible(false);
                } else {
                    removeClasses();
                    $(this).addClass('table-info selected-row');
                    setSelectedRow([...data]);
                    setEditRowVisible(true);
                }
            });
        }
    });

    DataTable.use(DT);
    const db = getDatabase();

    function firebaseToString(value) {
        return String(value)
            .replace(/_/g, ' ')
            .replace(/\*/g, '/')
            .replace(/\+/g, '.');
    }

    const flattenData = (obj) => {
        let result = [];
        let emp = {};

        for (let empresa of Object.keys(obj)) {
            if (typeof (obj[empresa]) == "object" && !Array.isArray(obj[empresa])) {
                let departamentos = obj[empresa];
                emp[firebaseToString(empresa)] = [];

                for (let departamento of Object.keys(departamentos)) {
                    let alunos = departamentos[departamento];

                    if (typeof (departamentos[departamento]) === 'object' && departamento !== 'instrutores') {
                        emp[firebaseToString(empresa)].push(firebaseToString(departamento));
                    }

                    if (typeof (alunos) === "object" && !Array.isArray(alunos)) {
                        for (let aluno of Object.keys(alunos)) {
                            if (alunos[aluno].NAME && alunos[aluno].isEmployeeVisible !== false) {
                                let id = aluno;
                                let nome = alunos[aluno].NAME;
                                let path = `${empresa}/${departamento}/${id}`;

                                result.push([
                                    path,
                                    id,
                                    firebaseToString(nome),
                                    firebaseToString(empresa),
                                    firebaseToString(departamento)
                                ]);
                            }
                        }
                    }
                }
            }
        }

        setEmpresas(emp);
        return result;
    }

    useEffect(() => {
        onValue(ref(db, '/companies/'), (snapshot) => {
            let result = flattenData(snapshot.val());
            setAlunos(result);
        });
    }, []);

    return (
        <>
            <MainNav />

            <Container>
                <h3 className='py-3'>Alunos</h3>
                {
                    editRowVisible && editData.length > 0 && (
                        <div className='position-relative'>
                            <div className='position-absolute top-0 start-50 translate-middle-x w-50 p-2 d-flex justify-content-around border border-3 border-primary-subtle rounded-3'>
                                <EditarAluno data={editData} departamentos={empresas[editData[3]] || []} empresas={empresas} />
                                <ExcluirAluno removeClasses={removeClasses} data={editData} />
                            </div>
                        </div>
                    )
                }
                <DataTable
                    data={alunos}
                    options={options}
                    className='table table-hover'
                />
            </Container>
        </>
    );
}

export default Alunos;
